export default __webpack_public_path__ + "static/media/Tips_for_a_Successful_Website_Redesign_in_2021.0a6bfbdd.pdf";